import { create } from 'zustand';
import { IExposureHistory } from '../utils/exposureUtils';

export interface IExposureHistoryStore {
  results: IExposureHistory[];
  isFetching: boolean;
  error: string | null;
  refetchHistory: () => void;
  setResults: (_results: IExposureHistory[]) => void;
  setIsFetching: (_isFetching: boolean) => void;
  setError: (_error: string | null) => void;
  clearHistory: () => void;
}

export const useExposureHistoryStore = create<IExposureHistoryStore>((set) => ({
  results: [],
  isFetching: false,
  error: null,

  refetchHistory: () => {
    // This will be implemented by the React Query hook
    set({ isFetching: true, error: null });
  },

  setResults: (results: IExposureHistory[]) => {
    set({
      results,
      isFetching: false,
      error: null,
    });
  },

  setIsFetching: (isFetching: boolean) => {
    set({ isFetching });
  },

  setError: (error: string | null) => {
    set({
      error,
      isFetching: false,
    });
  },

  clearHistory: () => {
    set({
      results: [],
      isFetching: false,
      error: null,
    });
  },
}));
